const changeEvent = function () {
  let currentImg = $('.activeSlider-1');
  let nextImg = currentImg.next();
  let prevImg;
  let sliederElementAmount = currentImg.siblings().length;
  if (sliederElementAmount >= 1) {
    if (nextImg.length) {
      currentImg.removeClass('activeSlider-1');
      nextImg.addClass('activeSlider-1');
    } else {
      prevImg = currentImg.prev();
      if (sliederElementAmount == 2) {
        prevImg = prevImg.prev();
      }
      currentImg.removeClass('activeSlider-1');
      prevImg.addClass('activeSlider-1');
    }
  }
};

$(document).ready(function () {
  setInterval(changeEvent, 5000);
});
